
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0B1F3B] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 sm:gap-12 lg:gap-16 items-start">
          {/* Logo Section */}
          <div className="flex justify-center lg:justify-start sm:col-span-2 lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/fab5168e291508d3586d4b84ed71e8b7/46cb40e7b05280b560bcee6a29da1570.png"
              alt="Brand Capital"
              className="h-24 sm:h-28 lg:h-32 w-auto"
            />
          </div>

          {/* Contatti Section */}
          <div className="text-center sm:text-left">
            <h4 className="text-lg sm:text-xl font-semibold mb-6 sm:mb-8 text-[#E879F9]">Contatti</h4>
            <ul className="space-y-4 sm:space-y-5">
              <li className="flex items-start justify-center sm:justify-start text-sm sm:text-base text-white/90">
                <i className="ri-mail-line mr-3 sm:mr-4 mt-1 text-lg sm:text-xl text-[#22C55E]"></i>
                <span className="break-all">info@brandcapital.it</span>
              </li>
              <li className="flex items-start justify-center sm:justify-start text-sm sm:text-base text-white/90">
                <i className="ri-phone-line mr-3 sm:mr-4 mt-1 text-lg sm:text-xl text-[#22C55E]"></i>
                <span>327 690 8748</span>
              </li>
            </ul>
          </div>

          {/* Posizione e P.IVA Section */}
          <div className="text-center sm:text-left">
            <h4 className="text-lg sm:text-xl font-semibold mb-6 sm:mb-8 text-[#E879F9]">Sede</h4>
            <ul className="space-y-4 sm:space-y-5">
              <li className="flex items-start justify-center sm:justify-start text-sm sm:text-base text-white/90">
                <i className="ri-map-pin-line mr-3 sm:mr-4 mt-1 text-lg sm:text-xl text-[#22C55E]"></i>
                <span>Modena, Italia</span>
              </li>
              <li className="flex items-start justify-center sm:justify-start text-sm sm:text-base text-white/90">
                <i className="ri-file-text-line mr-3 sm:mr-4 mt-1 text-lg sm:text-xl text-[#22C55E]"></i>
                <span>P.IVA 04112000361</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 sm:mt-14 lg:mt-16 pt-8 sm:pt-10 text-center">
          <p className="text-sm sm:text-base text-white/60">
            © 2025 Brand Capital. Tutti i diritti riservati.{' '}
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-[#22C55E] hover:text-[#22C55E]/80 transition-colors">
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
